export const heroData = {
  title: "News",
  subtitle: "The latest updates and announcements from AIRDOA.",
  image:
    "https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20with%20natural%20light%2C%20open%20notebook%20and%20laptop%20on%20clean%20desk%2C%20warm%20ambient%20lighting%2C%20editorial%20news%20update%20concept%2C%20no%20text&width=1920&height=600&seq=newshero01&orientation=landscape",
};

export const newsItems = [
  {
    title: "Yokohama Helicopter Cruise — Special Golden Week 2025 Plans",
    category: "News",
    date: "2025.04.01",
    slug: "yokohama-golden-week-2025",
    excerpt: "Special plans available during Golden Week 2025. Find out everything you need to know.",
  },
  {
    title: "Gift Ticket Early Purchase Bonus",
    category: "News",
    date: "2025.03.20",
    slug: "gift-ticket-early-benefit",
    excerpt: "Purchase a gift ticket by the end of April and receive an exclusive bonus. Limited-time campaign.",
  },
  {
    title: "New Articles Published",
    category: "Column",
    date: "2025.03.15",
    slug: "column-update",
    excerpt: "New articles are now available, including '5 Tips for a Perfect Yokohama Helicopter Date.'",
  },
  {
    title: "AIRDOA Is Now Open",
    category: "News",
    date: "2025.01.01",
    slug: "airdoa-open",
    excerpt: "AIRDOA, the Yokohama helicopter cruise booking media, is officially open. Stay tuned for more.",
  },
];
